import React, { useCallback, useRef, useState } from 'react';
import Button from '@material-ui/core/Button';
import Popover from '@material-ui/core/Popover';
import Paper from '@material-ui/core/Paper';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import MenuList from '@material-ui/core/MenuList';

import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';

/**
 * Reusable single dropdown menu using the Button + Popover + MenuList pattern.
 * Styled with contained primary button (consistent with ADD button pattern).
 * @param {Object} props
 * @param {React.ReactNode} props.label - Button label
 * @param {boolean} props.disabled - Whether the button is disabled
 * @param {Function} props.children - Render function receiving a closeMenu callback
 */
export const MenusItemsArrayButton = ({ label, disabled, children }) => {
    const [open, setOpen] = useState(false);
    const anchorRef = useRef(null);

    const handleToggle = useCallback(() => {
        setOpen((prev) => !prev);
    }, []);

    const handleClose = useCallback((event) => {
        if (anchorRef.current && anchorRef.current.contains(event.target)) {
            return;
        }
        setOpen(false);
    }, []);

    const closeMenu = useCallback(() => setOpen(false), []);

    return (
        <>
            <Button
                ref={anchorRef}
                variant="contained"
                color="primary"
                size="medium"
                disabled={disabled}
                onClick={handleToggle}
                endIcon={<ArrowDropDownIcon />}
                aria-controls={open ? `${label}-menu` : undefined}
                aria-expanded={open ? 'true' : undefined}
                aria-haspopup="menu"
            >
                {label}
            </Button>
            <Popover
                open={open}
                anchorEl={anchorRef.current}
                onClose={closeMenu}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
                transformOrigin={{ vertical: 'top', horizontal: 'left' }}
            >
                <Paper>
                    <ClickAwayListener onClickAway={handleClose}>
                        <MenuList>{children(closeMenu)}</MenuList>
                    </ClickAwayListener>
                </Paper>
            </Popover>
        </>
    );
};
